module.exports = __webpack_public_path__ + "static/media/02-1-c.e803ddda.webp";